(function() {
  "use strict";

  const dropdown = $(".dropdown");

  dropdown.on("click", function(e) {
    e.preventDefault();
    $(this)
      .find(".dropdown-menu")
      .toggleClass("open");
  });

  $(document).on("click", function(e) {
    if (dropdown !== e.target && !dropdown.has(e.target).length) {
      $(".dropdown-menu").removeClass("open");
    }
  });

  $(".dropdown-menu").on("click", function(e) {
    e.stopPropagation();
  });
})();
